import React from 'react'

export default function PageLoader() {
  return (
    <React.Fragment>
        <div className="load" style={{visibility: ''}}></div>
    </React.Fragment>
  )
}
